var _path, _path2, _g, _path3, _path4, _path5, _g2, _g3, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0596 3.19043C42.4629 1.22561 46.6562 1.22557 50.0596 3.19043L78.5244 19.625C81.9278 21.59 84.0244 25.2215 84.0244 29.1514V62.0186C84.0244 65.9485 81.9279 69.58 78.5244 71.5449L50.0596 87.9785C46.6562 89.9434 42.4629 89.9434 39.0596 87.9785L10.5947 71.5449C7.19127 69.58 5.09376 65.9485 5.09375 62.0186V29.1514C5.09375 25.2214 7.19126 21.5899 10.5947 19.625L39.0596 3.19043Z",
    fill: "#F3F0FF",
    stroke: "#CFBFFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2475_18050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 78,
    height: 87
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0595 3.76789C42.844 2.16026 46.2747 2.16026 49.0593 3.76789L78.5245 20.7793C81.3092 22.3869 83.0246 25.3581 83.0246 28.5735V62.5959C83.0246 65.8113 81.3092 68.7825 78.5245 70.3902L49.0593 87.4015C46.2747 89.0092 42.844 89.0092 40.0595 87.4015L10.5942 70.3902C7.80958 68.7825 6.09415 65.8113 6.09415 62.5959V28.5735C6.09415 25.3581 7.80957 22.3869 10.5942 20.7793L40.0595 3.76789Z",
    fill: "#EDF2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2475_18050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2216 53.7934C16.2948 48.1431 19.1739 42.5517 24.3117 40.0242L41.1326 31.7492C42.1881 31.23 43.3092 30.8564 44.4652 30.6387L71.6248 25.524C78.4761 24.2337 85.1254 28.5776 86.6964 35.37L93.1223 63.1525C94.5217 69.2031 91.4462 75.3985 85.7805 77.9418L46.9179 95.3868C41.5962 97.7757 35.3349 96.3273 31.6029 91.8442L23.7305 82.3875C22.2478 80.6065 21.2682 78.4614 20.893 76.1746L17.2216 53.7934Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4208 81.6373C23.7261 83.2209 25.1793 84.3421 26.8395 84.4016C26.8489 84.4006 26.8584 84.3996 26.8679 84.3987C26.9203 84.394 26.9772 84.3909 27.0381 84.3906L27.552 84.3359L27.5626 84.3347L27.5733 84.3337L94.0349 78.0836L82.5678 18.6037L13.8236 31.8567L23.4208 81.6373ZM97.3256 78.1131C97.5974 79.5232 96.5004 80.8754 94.9678 81.0192L27.8199 87.3339L27.0498 87.416L27.0238 87.4211L27.0037 87.4209L26.8998 87.432L26.8477 87.42C23.669 87.3995 20.8424 85.3022 20.2535 82.2479L10.5451 31.8905C10.2921 30.578 11.2282 29.2937 12.6356 29.0223L82.6152 15.5311C84.0189 15.2605 85.3701 16.1003 85.6238 17.4163L97.3256 78.1131Z",
    fill: "#CFBFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2475_18050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 78.4239L24.1424 94.0231L101.769 81.8364L31.7354 74.2939C29.7241 82.0515 24.0738 80.2795 21.5 78.4239Z",
    fill: "#B197FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.3827 43.7966L86.9459 30.193L84.6694 18.3852L14.1063 31.9889L16.3827 43.7966ZM90.3058 30.1298C90.5373 31.3306 89.5685 32.5268 88.1431 32.8016L16.2412 46.6634C14.8152 46.9383 13.4715 46.1878 13.24 44.9871L10.7463 32.0521C10.5148 30.8513 11.4831 29.6551 12.9091 29.3802L84.8111 15.5184C86.2365 15.2436 87.5806 15.9939 87.8121 17.1948L90.3058 30.1298Z",
    fill: "#CFBFFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4615 4.64604L16.8231 1.81828L19.8333 4.66742L12.8735 7.68524L10.4615 4.64604Z",
    fill: "#7950F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4515 3.25716L67.0263 3.07633L66.0407 1.6869L61.0928 1.90836L62.4515 3.25716Z",
    fill: "#FFEC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6137 5.66388L77.401 10.7567L78.2965 8.13213L75.504 3.52745L74.6137 5.66388Z",
    fill: "#FFC9C9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2475_18050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12992,
    y: 0.850467,
    width: 8.86833,
    height: 8.86825,
    rx: 4,
    transform: "matrix(0.990191 -0.139723 0.139725 0.99019 20.1178 43.9924)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2543 42.3344C32.5272 42.5443 32.6074 42.9552 32.4333 43.2522L27.9753 50.8576C27.8012 51.1546 27.4389 51.2253 27.1659 51.0154L23.6716 48.3287C23.3987 48.1188 23.3186 47.7079 23.4926 47.4109C23.6667 47.1139 24.0291 47.0432 24.302 47.2531L27.3022 49.5599L31.4449 42.4922C31.619 42.1952 31.9814 42.1246 32.2543 42.3344Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.156 42.3205C31.4318 41.8506 32.0244 41.7349 32.4565 42.0669C32.8628 42.3793 32.9792 42.9762 32.7202 43.4184L28.2616 51.0241C27.9858 51.4943 27.3932 51.6099 26.9611 51.2777L23.4665 48.5912C23.0604 48.2787 22.9447 47.6817 23.2037 47.2396C23.4795 46.7694 24.0721 46.6538 24.5043 46.9861L27.2035 49.0609L31.156 42.3205ZM32.049 42.5969C31.9355 42.5098 31.8048 42.5358 31.7324 42.6593L27.5894 49.7264C27.5409 49.8089 27.4591 49.8669 27.3652 49.8853C27.2712 49.9036 27.1729 49.8809 27.097 49.8225L24.0967 47.515C23.9833 47.4282 23.8524 47.4542 23.78 47.5774C23.6911 47.7292 23.7345 47.954 23.874 48.0613L27.3687 50.7487C27.4821 50.8355 27.613 50.8095 27.6854 50.6863L32.1439 43.0805C32.2326 42.9287 32.1883 42.704 32.049 42.5969Z",
    fill: "#F3F0FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2475_18050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12992,
    y: 0.850467,
    width: 8.86833,
    height: 8.86825,
    rx: 4,
    transform: "matrix(0.990191 -0.139723 0.139725 0.99019 22.5553 59.5373)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6918 57.8774C34.9647 58.0872 35.0449 58.4981 34.8708 58.7951L30.4128 66.4006C30.2387 66.6976 29.8764 66.7682 29.6034 66.5584L26.1091 63.8716C25.8362 63.6618 25.7561 63.2509 25.9301 62.9539C26.1042 62.6569 26.4666 62.5862 26.7395 62.7961L29.7397 65.1029L33.8824 58.0352C34.0565 57.7382 34.4189 57.6675 34.6918 57.8774Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5925 57.8665C33.8682 57.3965 34.4609 57.2812 34.8931 57.613C35.2994 57.9254 35.4159 58.5222 35.1567 58.9644L30.6991 66.57C30.4234 67.0403 29.8308 67.1558 29.3986 66.8236L25.904 64.1371C25.4977 63.8246 25.3812 63.2278 25.6403 62.7856C25.916 62.3152 26.5096 62.1996 26.9418 62.532L29.6412 64.6078L33.5925 57.8665ZM34.4865 58.1427C34.373 58.0555 34.2413 58.0818 34.1689 58.2053L30.0259 65.2725C29.9774 65.355 29.8957 65.413 29.8017 65.4313C29.7078 65.4496 29.6104 65.4267 29.5345 65.3684L26.5342 63.0609C26.4207 62.9739 26.289 63 26.2166 63.1235C26.1277 63.2753 26.172 63.4999 26.3115 63.6072L29.8052 66.2948C29.9187 66.3819 30.0504 66.3556 30.1229 66.2322L34.5806 58.6275C34.6696 58.4757 34.626 58.25 34.4865 58.1427Z",
    fill: "#F3F0FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2475_18050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12992,
    y: 0.850467,
    width: 8.86833,
    height: 8.86825,
    rx: 4,
    transform: "matrix(0.990191 -0.139723 0.139725 0.99019 17.9333 27.4777)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0698 25.8188C30.3427 26.0286 30.4228 26.4395 30.2487 26.7365L25.7908 34.342C25.6167 34.639 25.2543 34.7096 24.9814 34.4998L21.487 31.813C21.2141 31.6032 21.134 31.1923 21.3081 30.8953C21.4822 30.5983 21.8446 30.5276 22.1175 30.7375L25.1176 33.0443L29.2604 25.9766C29.4344 25.6796 29.7968 25.609 30.0698 25.8188Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9714 25.8068C29.2472 25.3368 29.8398 25.2212 30.272 25.5533C30.6782 25.8657 30.7947 26.4625 30.5356 26.9047L26.0771 34.5105C25.8012 34.9805 25.2086 35.0962 24.7765 34.764L21.2829 32.0774C20.8765 31.7649 20.76 31.1681 21.0192 30.7259C21.295 30.2557 21.8875 30.1401 22.3198 30.4724L25.019 32.5472L28.9714 25.8068ZM29.8645 26.0832C29.7511 25.9962 29.6201 26.0216 29.5477 26.1446L25.4048 33.2128C25.3564 33.2953 25.2745 33.3532 25.1806 33.3716C25.0866 33.3899 24.9884 33.3672 24.9124 33.3089L21.9121 31.0013C21.7987 30.9145 21.6678 30.9404 21.5955 31.0638C21.5065 31.2156 21.5499 31.4403 21.6894 31.5476L25.184 34.2341C25.2975 34.3212 25.4293 34.2959 25.5018 34.1725L29.9593 26.5669C30.0481 26.4151 30.0038 26.1904 29.8645 26.0832Z",
    fill: "#F3F0FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6286 28.6257C39.8328 27.4216 41.4659 26.7451 43.1688 26.7451H49.5895C51.2924 26.7451 52.9256 27.4216 54.1297 28.6257C55.3338 29.8298 56.0103 31.4629 56.0103 33.1657V39.5863C56.0103 40.7231 55.7088 41.8289 55.1501 42.7966C55.7088 43.7644 56.0103 44.8701 56.0103 46.0069V52.4275C56.0103 54.1303 55.3338 55.7634 54.1297 56.9675C52.9256 58.1716 51.2924 58.8481 49.5895 58.8481H43.1688C41.4659 58.8481 39.8328 58.1716 38.6286 56.9675C37.4245 55.7634 36.748 54.1303 36.748 52.4275C36.748 50.6545 38.1854 49.2172 39.9584 49.2172C41.7315 49.2172 43.1688 50.6545 43.1688 52.4275H49.5895V46.0069H43.1688C41.3958 46.0069 39.9584 44.5696 39.9584 42.7966C39.9584 41.0236 41.3958 39.5863 43.1688 39.5863H49.5895V33.1657H43.1688C43.1688 34.9387 41.7315 36.376 39.9584 36.376C38.1854 36.376 36.748 34.9387 36.748 33.1657C36.748 31.4629 37.4245 29.8298 38.6286 28.6257Z",
    fill: "#212529"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6286 28.6257C39.8328 27.4216 41.4659 26.7451 43.1688 26.7451H49.5895C51.2924 26.7451 52.9256 27.4216 54.1297 28.6257C55.3338 29.8298 56.0103 31.4629 56.0103 33.1657V39.5863C56.0103 40.7231 55.7088 41.8289 55.1501 42.7966C55.7088 43.7644 56.0103 44.8701 56.0103 46.0069V52.4275C56.0103 54.1303 55.3338 55.7634 54.1297 56.9675C52.9256 58.1716 51.2924 58.8481 49.5895 58.8481H43.1688C41.4659 58.8481 39.8328 58.1716 38.6286 56.9675C37.4245 55.7634 36.748 54.1303 36.748 52.4275C36.748 50.6545 38.1854 49.2172 39.9584 49.2172C41.7315 49.2172 43.1688 50.6545 43.1688 52.4275H49.5895V46.0069H43.1688C41.3958 46.0069 39.9584 44.5696 39.9584 42.7966C39.9584 41.0236 41.3958 39.5863 43.1688 39.5863H49.5895V33.1657H43.1688C43.1688 34.9387 41.7315 36.376 39.9584 36.376C38.1854 36.376 36.748 34.9387 36.748 33.1657C36.748 31.4629 37.4245 29.8298 38.6286 28.6257Z",
    fill: "#7950F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0713 29.0459C63.9122 27.2051 66.4089 26.1709 69.0122 26.1709C71.6156 26.1709 74.1123 27.2051 75.9532 29.0459C77.794 30.8867 78.8282 33.3834 78.8282 35.9867V49.0744C78.8282 51.6778 77.794 54.1744 75.9532 56.0153C74.1123 57.8561 71.6156 58.8902 69.0122 58.8902C66.4089 58.8902 63.9122 57.8561 62.0713 56.0153C60.2305 54.1744 59.1963 51.6778 59.1963 49.0744V35.9867C59.1963 33.3834 60.2305 30.8867 62.0713 29.0459ZM69.0122 32.7148C68.1445 32.7148 67.3122 33.0595 66.6986 33.6731C66.085 34.2867 65.7403 35.1189 65.7403 35.9867V49.0744C65.7403 49.9422 66.085 50.7744 66.6986 51.388C67.3122 52.0017 68.1445 52.3464 69.0122 52.3464C69.88 52.3464 70.7123 52.0017 71.3259 51.388C71.9395 50.7744 72.2842 49.9422 72.2842 49.0744V35.9867C72.2842 35.1189 71.9395 34.2867 71.3259 33.6731C70.7123 33.0595 69.88 32.7148 69.0122 32.7148Z",
    fill: "#212529"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0713 29.0459C63.9122 27.2051 66.4089 26.1709 69.0122 26.1709C71.6156 26.1709 74.1123 27.2051 75.9532 29.0459C77.794 30.8867 78.8282 33.3834 78.8282 35.9867V49.0744C78.8282 51.6778 77.794 54.1744 75.9532 56.0153C74.1123 57.8561 71.6156 58.8902 69.0122 58.8902C66.4089 58.8902 63.9122 57.8561 62.0713 56.0153C60.2305 54.1744 59.1963 51.6778 59.1963 49.0744V35.9867C59.1963 33.3834 60.2305 30.8867 62.0713 29.0459ZM69.0122 32.7148C68.1445 32.7148 67.3122 33.0595 66.6986 33.6731C66.085 34.2867 65.7403 35.1189 65.7403 35.9867V49.0744C65.7403 49.9422 66.085 50.7744 66.6986 51.388C67.3122 52.0017 68.1445 52.3464 69.0122 52.3464C69.88 52.3464 70.7123 52.0017 71.3259 51.388C71.9395 50.7744 72.2842 49.9422 72.2842 49.0744V35.9867C72.2842 35.1189 71.9395 34.2867 71.3259 33.6731C70.7123 33.0595 69.88 32.7148 69.0122 32.7148Z",
    fill: "#7950F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1685 18.433L54.5361 14.4534L56.5258 11.2695L63.689 15.6469L61.1685 18.433Z",
    fill: "#FFC9C9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5961 42.4071L81.3999 38.1098L83.2199 35.0291L88.8272 39.7495L86.5961 42.4071Z",
    fill: "#99E9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7791 22.4557L18.7858 19.6901L20.1494 17.7501L24.554 18.3321L22.7791 22.4557Z",
    fill: "#99E9F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.844896 36.8891L5.40417 32.3754L6.60661 34.775L1.63589 39.6309L0.844896 36.8891Z",
    fill: "#99E9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3609 75.6141L15.4863 72.404L16.2661 74.0656L12.8595 77.5199L12.3609 75.6141Z",
    fill: "#7950F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6392 20.9078L69.5399 18.0131L70.9399 19.927L66.6805 23.0344L65.6392 20.9078Z",
    fill: "#7950F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6645 3.42241L31.9711 5.90744L33.0641 9.74312L27.2842 6.97622L26.6645 3.42241Z",
    fill: "#99E9F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 20.0366L27.6377 17.4132L26.3261 15.3145L21.6041 18.2L23.2656 20.0366Z",
    fill: "#FFEC99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3587 3.10677L66.9335 2.92594L65.9479 1.53651L61 1.75797L62.3587 3.10677Z",
    fill: "#FFEC99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6421 13.8176L66.8855 14.9175L67.7578 13.3099L64.2215 12.1451L63.6421 13.8176Z",
    fill: "#FFEC99"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3651 75.1877L47.5154 76.791L48.9744 74.2301L43.3575 72.5361L42.3651 75.1877Z",
    fill: "#FFEC99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58146 11.5572L16.2139 7.57759L15.0687 5.83398L8.48864 9.80112L9.58146 11.5572Z",
    fill: "#FFC9C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5199 5.51251L77.3073 10.6053L78.2028 7.98077L75.4103 3.37608L74.5199 5.51251Z",
    fill: "#FFC9C9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7847 80.9183L80.7343 81.542L79.6709 79.4267L75.022 79.0722L75.7847 80.9183Z",
    fill: "#FFC9C9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0658 36.1259L20.6982 33.5945L18.7085 31.5693L11.5453 34.3538L14.0658 36.1259Z",
    fill: "#FFC9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2475_18050",
    x: 7.9,
    y: 68.6939,
    width: 93.8686,
    height: 30.9295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.677775 0 0 0 0 0.599488 0 0 0 0 0.903602 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2475_18050",
    x: 13.875,
    y: 37.877,
    width: 19.9834,
    height: 20.0615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2475_18050",
    x: 16.3125,
    y: 53.4229,
    width: 19.9824,
    height: 20.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2475_18050",
    x: 11.6904,
    y: 21.3633,
    width: 19.9834,
    height: 20.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18050",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/30.f834934f9c132debbda8de9bb6c1ea5b.svg";
export { ForwardRef as ReactComponent };